<template>
    <div>
        <h3>{{resource.subtitle}}</h3>


        <iframe class='youtubeViewer' :src="'https://www.youtube-nocookie.com/embed/' + videoId(resource.url)  + '?cc_load_policy=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    
        <iframe class='youtubeViewer' v-if='resource.url2' :src="'https://www.youtube-nocookie.com/embed/' + videoId(resource.url2) + '?cc_load_policy=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

        <div v-html='resource.content'>
            
        </div>
    </div>
</template>

<style>
iframe.youtubeViewer {
    width: 100%;
    height: 632px;
}

@media only screen and (max-width: 1200px) {
    iframe.youtubeViewer {
        height: 632px;
    }
}

@media only screen and (max-width: 980px) {
iframe.youtubeViewer {
    height: 400px;
}
}

@media only screen and (max-width: 414px) {
    iframe.youtubeViewer {
        height: 300px;
    }
}

@media only screen and (max-width: 375px) {
    iframe.youtubeViewer {
        height: 200px;
    }
}

</style>

<script>
import util from '../util'

export default {
    name: 'youtube-viewer',
    props: ['resource'],
    methods: {
        videoId: util.videoId
    },  
}
</script>